module.exports = __webpack_public_path__ + "static/media/item_48_3.58ed6ee1.png";